document.addEventListener('DOMContentLoaded', () => {
  const thumbSliders = document.querySelectorAll('[data-thumb-for]')

  thumbSliders.forEach((thumbSlider) => {
    const mainSliderId =
      'Slider-Thumb-' +
      thumbSlider.getAttribute('data-thumb-for').replace('Slider-', '')
    const mainSlider = document.querySelector(
      `[data-thumb-slider="${mainSliderId}"]`
    )
    if (!mainSlider) return

    const thumbSlides = Array.from(
      thumbSlider.querySelectorAll('.slider__slide')
    )
    const mainSlides = Array.from(mainSlider.querySelectorAll('.slider__slide'))

    // initialize active
    const setActiveSlide = (index) => {
      thumbSlides.forEach((t) => t.classList.remove('active'))
      mainSlides.forEach((s) => s.classList.remove('active'))

      thumbSlides[index].classList.add('active')
      mainSlides[index].classList.add('active')
    }

    setActiveSlide(0)

    // thumbnail click
    thumbSlides.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        setActiveSlide(index)

        // 🔹 slide thumb into view
        thumb.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        })
      })
    })

    // prev/next buttons
    const prevBtn = thumbSlider.querySelector('.slider-button--prev')
    const nextBtn = thumbSlider.querySelector('.slider-button--next')

    const changeSlide = (dir) => {
      let activeIndex = thumbSlides.findIndex((t) =>
        t.classList.contains('active')
      )

      activeIndex =
        dir === 'next'
          ? Math.min(activeIndex + 1, thumbSlides.length - 1)
          : Math.max(activeIndex - 1, 0)

      setActiveSlide(activeIndex)

      // 🔹 slide container to active thumb
      thumbSlides[activeIndex].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      })
    }

    prevBtn?.addEventListener('click', () => changeSlide('prev'))
    nextBtn?.addEventListener('click', () => changeSlide('next'))
  })
})
